import { render, staticRenderFns } from "./SpecChoose.vue?vue&type=template&id=b75add96"
import script from "./SpecChoose.vue?vue&type=script&lang=js"
export * from "./SpecChoose.vue?vue&type=script&lang=js"
import style0 from "./SpecChoose.vue?vue&type=style&index=0&id=b75add96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports